import React, { useState } from 'react';
import Modal from './Modal';

export default function CashierLoginModal({ isOpen, onClose, onSuccess, cashiers = [] }) {
  const [selectedId, setSelectedId] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    const cashier = cashiers.find((c) => c._id === selectedId);
    if (!cashier) {
      setError('Please select a cashier');
      return;
    }
  
    if (cashier.pin === code) {
      onSuccess(cashier);
      setCode('');
      setSelectedId('');
      setError('');
    } else {
      setError('Invalid code');
    }
  };
  

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-semibold mb-4">Cashier Login</h2>

      <select
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value)}
        className="border px-3 py-2 w-full rounded mb-3"
      >
        <option value="">Select Cashier</option>
        {cashiers.map((cashier) => (
          <option key={cashier._id} value={cashier._id}>
            {cashier.name}
          </option>
        ))}
      </select>

      <input
        type="password"
        placeholder="Enter PIN"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        className="border px-3 py-2 w-full rounded mb-2"
      />

      {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

      <div className="flex justify-end space-x-2 mt-4">
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
          Cancel
        </button>
        <button onClick={handleLogin} className="px-4 py-2 bg-blue-600 text-white rounded">
          Login
        </button>
      </div>
    </Modal>
  );
}
